import axios from 'axios';

const configuredBase = String(process.env.REACT_APP_API_BASE || 'https://localhost:7192/api/').replace(/^['"]|['"]$/g, '');
export const API_BASE_URL = configuredBase.endsWith('/') ? configuredBase : `${configuredBase}/`;

export async function getApi<T>(endpoint: string): Promise<T> {
  const response = await axios.get<T>(`${API_BASE_URL}${endpoint.replace(/^\//, '')}`);
  return response.data;
}
